import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import RegionsDetailsForm from '../RegionsDetailsForm';

import { ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_regionsDeleteModal.module.scss';
import { TEditRegionDetailsReduxParams } from '~types/feat/branch';

const RegionsDeleteModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.deleteRegionModalIsOpen);
    // const isEditing = useAppSelector(state => state.branch.modals.isEditing);
    const isLoading = useAppSelector(state => state.branch.loadings.editRegionDetails);
    const editBranchDetailsError = useAppSelector(state => state.branch.errors.editRegionDetails);
    const regionDetails = useAppSelector(state => state.branch.selectedRegion);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.BranchManagement);

    if (!regionDetails || !hasEditAccess) return null;

    const handleModalOnClose = () => {
        dispatch(combinedActions.branchSetDeleteRegionModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditRegionDetailsReduxParams) => dispatch(combinedActions.branchEditRegionDetailsAttempt({ ...data, status: 2 }));

    return (
        <Modal
            title='Delete Region'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <div className={Styles.subcontainer}>
                <RegionsDetailsForm
                    submitButtonLabel='Delete'
                    actionButtonIsLoading={isLoading}
                    actionButtonClassName={Styles['action-button']}
                    actionButtonIsDisabled={true}
                    onSubmit={handleOnSubmit}
                    inputIsDisabled={true}
                    error={editBranchDetailsError}
                    isEditing={true}
                    initialRegionDetails={regionDetails}
                />
            </div>
        </Modal>
    );
};

export default RegionsDeleteModal;
